import { useState } from "react";
import { X } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BetaWelcomeBanner = ({ user, onDismiss }) => {
  const [dismissing, setDismissing] = useState(false);

  const handleDismiss = async () => {
    setDismissing(true);
    try {
      await axios.put(`${API}/users/me/dismiss-beta-welcome`, {}, { withCredentials: true });
      onDismiss();
    } catch (error) {
      console.error("Error dismissing banner:", error);
      onDismiss(); // Dismiss anyway
    }
  };

  // Only show for beta users who haven't dismissed
  if (!user?.beta_mode || user?.beta_welcome_dismissed) {
    return null;
  }

  const firstName = user?.name?.split(' ')[0] || 'there';

  return (
    <div 
      className="mb-6 p-4 rounded-sm border-l-[3px] border-l-[#C8860A] bg-[rgba(200,134,10,0.06)]"
      style={{ borderRadius: '2px' }}
      data-testid="beta-welcome-banner"
    >
      <div className="flex items-start justify-between gap-4">
        <p className="text-white text-[13px]" style={{ fontFamily: 'DM Sans, sans-serif' }}>
          Welcome, {firstName}. You have founding member access - all features 
          unlocked for 90 days. We'll be in touch at the 3-week mark for a 
          brief conversation.
        </p>
        <button
          onClick={handleDismiss}
          disabled={dismissing}
          className="text-slate-500 hover:text-white transition-colors p-1 flex-shrink-0"
          aria-label="Dismiss"
          data-testid="dismiss-beta-banner"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default BetaWelcomeBanner;
